import React from "react";

import UIcon from "../../lib/icons/untitled_ui/UIcon";
import { Flex } from "../../styles/utility-components";
import SuppliersContainer from "./SuppliersContainer";
import { EmptyLogoImage, LogoImage, TableCell } from "./TableCellStyles";

export interface SupplierRecord {
  id: string;
  name?: string | null;
  logoUrl?: string | null;
}

export interface SupplierWithLogoCellProps {
  suppliers: SupplierRecord[];
  recordName?: string | null;
  minWidth?: number;
}

export const SupplierWithLogoCell: React.FC<SupplierWithLogoCellProps> = ({
  suppliers,
  recordName,
  minWidth,
}) => {
  if (!suppliers || suppliers.length === 0) {
    return <TableCell minWidth={minWidth}>-</TableCell>;
  }
  const first = suppliers[0];
  const mappedSuppliers = suppliers.map((s) => ({ guid: s.id, name: s.name || "--" }));
  return (
    <TableCell minWidth={minWidth}>
      <Flex alignItems="center" gap={8}>
        {first.logoUrl ? (
          <LogoImage src={first.logoUrl} alt={`${first.name || "Supplier"} logo`} />
        ) : (
          <EmptyLogoImage>
            <UIcon icon="trophy01" size={12} />
          </EmptyLogoImage>
        )}
        <SuppliersContainer recordName={recordName || "--"} suppliers={mappedSuppliers} />
      </Flex>
    </TableCell>
  );
};
